import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'src/app/core/auth/auth.guard';
import { CanActivateChildGuard } from 'src/app/core/guards/can-activate-child.guard';
import { UpdateAsEnterpriseComponent } from './update-as-enterprise/update-as-enterprise.component';


const routes: Routes = [
  {
    path: 'kyc-confirm-account/update-enterprise/:id',
    component: UpdateAsEnterpriseComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    // canDeactivate: [ConfirmDeactivateGuard],
  },
  {
    path: 'kyc-confirm-account/update-enterprise-anonymous/:id/:hashKey/:tenantId',
    component: UpdateAsEnterpriseComponent,
    // canDeactivate: [ConfirmDeactivateGuard],
  },
  {
    path: 'kyc-confirm-account/update-enterprise-anonymous/:id/:hashKey/:tenantId/:contractIdAndContractEnterpriseIdEncode',
    component: UpdateAsEnterpriseComponent,
    // canDeactivate: [ConfirmDeactivateGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class KycConfirmAccountRoutingModule { }
